import React from 'react'

export default (
<path d="M20.5 17L24 20.5L20.5 24L17 20.5L20.5 17Z" fill="currentColor"/>
)